module.exports = __webpack_public_path__ + "img/reclamos.1f6129e2.png";